<div class="register-page" [ngClass]="{ 'mobile-register-page': baseService.isMobile }">
  <div class="header">
    <a [href]="homeUrl">JECRM</a>
  </div>
  <div class="card-pf">
    <div class="title">
      <h1 class="title-text">{{ 'sign_up_account' | translate }}</h1>
    </div>
    <div class="content">
      @if (registerForm) {
        <div [formGroup]="registerForm" class="form" (keydown.enter)="onSubmit()">
          <div class="full-name">
            <app-input
              labelType="floating"
              variant="on"
              [formControl]="registerForm.controls.first_name"
              [disabled]="registerForm.controls.first_name.disabled"
              id="firstName"
              placeholder="{{ 'enter_first_name' | translate }}"
              [invalid]="registerForm.controls.first_name.invalid && registerForm.controls.first_name.touched"
              [required]="true"
            />
            <app-input
              labelType="floating"
              variant="on"
              [formControl]="registerForm.controls.last_name"
              [disabled]="registerForm.controls.last_name.disabled"
              id="lastName"
              placeholder="{{ 'enter_last_name' | translate }}"
              [invalid]="registerForm.controls.last_name.invalid && registerForm.controls.last_name.touched"
              [required]="true"
            />
          </div>
          <div class="form-element w-100">
            <app-input
              labelType="floating"
              [variant]="'on'"
              [inputType]="'phone'"
              [formControl]="registerForm.controls.phone_number"
              [disabled]="registerForm.controls.phone_number.disabled"
              [id]="'phone'"
              [invalid]="registerForm.controls.phone_number.invalid && registerForm.controls.phone_number.touched"
              [required]="true"
              [options]="PHONES_FOR_INPUT"
              [optionValue]="'value'"
              [optionLabel]="'title'"
            />
          </div>
          <div class="form-element w-100">
            <app-input
              labelType="floating"
              variant="on"
              [formControl]="registerForm.controls.email"
              [disabled]="registerForm.controls.email.disabled"
              id="email"
              placeholder="{{ 'enter_your_e-mail' | translate }}"
              [invalid]="registerForm.controls.email.invalid && registerForm.controls.email.touched"
              [required]="true"
            />
          </div>
          <div class="form-element w-100">
            <app-input
              labelType="floating"
              variant="on"
              id="password"
              inputType="password"
              [toggleMask]="true"
              [required]="true"
              placeholder="{{ 'enter_password' | translate }}"
              [invalid]="registerForm.controls.password.invalid && registerForm.controls.password.touched"
              [formControl]="registerForm.controls.password"
              [feedback]="true"
              [minlength]="6"
              promptLabel="{{ 'enter_password' | translate }}"
              weakLabel="{{ 'weak' | translate }}"
              mediumLabel="{{ 'medium' | translate }}"
              strongLabel="{{ 'strong' | translate }}"
            />
          </div>
          <div class="form-element w-100">
            <app-input
              labelType="floating"
              variant="on"
              id="password-confirm"
              inputType="password"
              [toggleMask]="true"
              [required]="true"
              placeholder="{{ 'enter_password_confirmation' | translate }}"
              [invalid]="
                registerForm.controls.password_confirmation.invalid &&
                registerForm.controls.password_confirmation.touched
              "
              [formControl]="registerForm.controls.password_confirmation"
              [minlength]="6"
            />
          </div>
          <a (click)="onLogin()" class="return-to-login">
            {{ 'return_to_login' | translate }}
          </a>
          <app-button [disabled]="isRegistering" [full]="true" (onChangeClick)="onSubmit()">
            {{ 'sign_up' | translate }}
          </app-button>
        </div>
      }
    </div>
  </div>
</div>
